exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".item-card__card-thumbnail{box-shadow:0 2px 10px 0 rgba(118,136,154,.16);border-radius:2px}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};